import formatOrig from 'date-fns/esm/format';
import formatDistanceToNowOrig from 'date-fns/esm/formatDistanceToNow';
import formatDistanceToNowStrictOrig from 'date-fns/esm/formatDistanceToNowStrict';
import { Locale } from 'date-fns';

import { getCurrentLocale, localeLowerCase } from './i18n';

interface DistanceOptions {
    includeSeconds?: boolean;
    addSuffix?: boolean;
    locale?: Locale;
}

// Create a cache object to store the loaded locales
const loadedLocales: { [key: string]: Locale } = {};

const getDateFnsLocale = (): Locale => {
    // Current locale can change, so load locale dynamically
    const currentLocale = getCurrentLocale();

    // Check if the locale has already been loaded and cached
    if (loadedLocales[currentLocale]) {
        return loadedLocales[currentLocale];
    }

    let locale: Locale;
    switch (currentLocale) {
        case 'ru':
            // eslint-disable-next-line
            locale = require('date-fns/esm/locale/ru').default;
            break;

        case 'en':
        default:
            // eslint-disable-next-line
            locale = require('date-fns/esm/locale/en-US').default;
            break;
    }

    // Cache the loaded locale
    loadedLocales[currentLocale] = locale;

    return locale;
};

export const format = (date: Date, formatStr: string) => {
    return formatOrig(date, formatStr, {
        locale: getDateFnsLocale(),
    });
};

export const formatDistanceToNow = (date: Date, options?: DistanceOptions) =>
    formatDistanceToNowOrig(date, {
        ...options,
        locale: getDateFnsLocale(),
    });

export const formatDistanceToNowStrict = (date: Date, options?: DistanceOptions) =>
    formatDistanceToNowStrictOrig(date, {
        ...options,
        locale: getDateFnsLocale(),
    });

export const formatDistanceToNowStrictLower = (date: Date, options?: DistanceOptions) =>
    localeLowerCase(formatDistanceToNowStrict(date, options));

// Parse a date string in the format YYYY-MM-DD... as a local date
export const parseDateStringAsLocal = (dateStr: string) => {
    const [year, month, day] = dateStr.substring(0, 10).split('-').map(Number);

    // Month is 0-indexed in the Date constructor, so subtract 1
    return new Date(year, month - 1, day);
};
